import { render, staticRenderFns } from "./PriceData.vue?vue&type=template&id=1fd4a90c&scoped=true"
import script from "./PriceData.vue?vue&type=script&lang=js"
export * from "./PriceData.vue?vue&type=script&lang=js"
import style0 from "./PriceData.vue?vue&type=style&index=0&id=1fd4a90c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd4a90c",
  null
  
)

export default component.exports